/** POS সিঙ্ক: POS ডিভাইস থেকে আসা যেসব বিল ও এন্ট্রি দেখা দরকার। */
export const pos = {
    report: {
        x: "এক্স-রিপোর্ট",
        z: "জেড-রিপোর্ট · শিফট বন্ধ",
        opened: "শুরু",
        closed: "বন্ধ",
        by: "দ্বারা",
        float: "শুরুর নগদ",
        bills: "বিল",
        returns: "ফেরত",
        sales: "বিক্রি",
        discounts: "ছাড়",
        vat: "ভ্যাট",
        rounding: "রাউন্ডিং",
        payments: "পেমেন্ট",
        credit: "বাকিতে",
        cashIn: "নগদ জমা",
        cashOut: "নগদ খরচ",
        expected: "প্রত্যাশিত নগদ",
        counted: "গোনা নগদ",
        variance: "পার্থক্য",
        denominations: "গণনা",
        note: "নোট",
        refunds: "রিফান্ড",
        toDues: "কাস্টমারের বাকি থেকে বাদ",
        exchanges: "এক্সচেঞ্জ",
        reasons: {
            petty_expense: "ছোট খরচ",
            bank_drop: "ব্যাংকে জমা",
            float_top_up: "খুচরা যোগ",
            other: "অন্যান্য",
        },
    },
    receipt: {
        bill: "বিল",
        date: "তারিখ",
        cashier: "ক্যাশিয়ার",
        customer: "কাস্টমার",
        bin: "BIN {{bin}}",
        subtotal: "সাবটোটাল",
        discount: "ছাড়",
        vat: "ভ্যাট",
        vatIncluded: "ভ্যাটসহ",
        rounding: "রাউন্ডিং",
        total: "মোট",
        paid: "পরিশোধ",
        change: "ফেরত",
        onCredit: "বাকি",
        reprint: "পুনঃমুদ্রণ",
        thanks: "আমাদের থেকে কেনার জন্য ধন্যবাদ",
        methods: { cash: "নগদ", card: "কার্ড", bkash: "বিকাশ", nagad: "নগদ (Nagad)", rocket: "রকেট" },
        reference: "রেফ {{ref}}",
        returnTitle: "পণ্য ফেরত",
        returnNumber: "ফেরত নং",
        originalBill: "মূল বিল",
        damaged: "ক্ষতিগ্রস্ত",
        refundTotal: "ফেরতের টাকা",
        toDues: "বাকি থেকে বাদ",
        exchangeFor: "এক্সচেঞ্জ → {{bill}}",
        exchangeCredit: "এক্সচেঞ্জ ক্রেডিট",
        reason: "কারণ",
    },
    app: {
        name: "POS",
        starting: "POS খুলছে…",
        startFailed: "এই কম্পিউটারে POS তার ডেটা খুলতে পারেনি।",
        language: "ভাষা",
        english: "English",
        bengali: "বাংলা",
        shiftMenu: {
            title: "শিফট",
            since: "{{time}} থেকে চালু · {{name}}",
            cash: "নগদ জমা / খরচ",
            xReport: "এক্স-রিপোর্ট",
            noSale: "ড্রয়ার খুলুন (বিক্রি ছাড়া)",
            noSaleDone: "ড্রয়ার খোলা হয়েছে।",
            close: "শিফট বন্ধ",
            print: "প্রিন্ট",
        },
        cash: {
            title: "নগদ জমা / খরচ",
            in: "নগদ জমা",
            out: "নগদ খরচ",
            amount: "পরিমাণ (৳)",
            reason: "কারণ",
            note: "নোট (ঐচ্ছিক)",
            save: "রেকর্ড করুন",
            saved: "রেকর্ড হয়েছে। ড্রয়ার খোলা।",
        },
        close: {
            countTitle: "নগদ গুনুন",
            countHelp: "নোট ও কয়েন অনুযায়ী ড্রয়ার গুনুন। গোনার পরে প্রত্যাশিত পরিমাণ দেখানো হবে।",
            counted: "গোনা হয়েছে",
            next: "পরের ধাপ",
            summaryTitle: "শিফট বন্ধ করুন",
            over: "{{amount}} বেশি",
            short: "{{amount}} কম",
            balanced: "মিলে গেছে",
            note: "নোট (ঐচ্ছিক)",
            confirm: "শিফট বন্ধ করে জেড-রিপোর্ট প্রিন্ট",
            closed: "শিফট বন্ধ হয়েছে। জেড-রিপোর্ট প্রিন্ট হয়েছে।",
            closedNoPrint: "শিফট বন্ধ হয়েছে।",
            back: "গণনায় ফিরুন",
        },
        approval: {
            title: "ম্যানেজারের অনুমোদন",
            reasons: {
                cash_out: "ড্রয়ার থেকে নগদ নিতে ম্যানেজার লাগবে।",
                line_void: "পণ্য সরাতে ম্যানেজার লাগবে।",
                bill_void: "কার্ট খালি করতে ম্যানেজার লাগবে।",
                no_sale: "বিক্রি ছাড়া ড্রয়ার খুলতে ম্যানেজার লাগবে।",
                refund_over_limit: "এই ফেরত সীমার বেশি, ম্যানেজার লাগবে।",
                receiptless_return: "রসিদ ছাড়া ফেরতে ম্যানেজার লাগবে।",
                discount_over_limit: "এই ছাড় সীমার বেশি, ম্যানেজার লাগবে।",
                price_override: "দাম বদলাতে ম্যানেজার লাগবে।",
                pin_unlock: "খুলতে ম্যানেজার লাগবে।",
            },
            approve: "অনুমোদন",
        },
        returns: {
            title: "ফেরত / এক্সচেঞ্জ",
            numberLabel: "বিল নম্বর",
            numberHelp: "রসিদের বারকোড স্ক্যান করুন বা বিল নম্বর লিখুন।",
            find: "বিল খুঁজুন",
            withoutReceipt: "রসিদ ছাড়া ফেরত",
            notFound: "এই কাউন্টারে বা সার্ভারে {{number}} বিল পাওয়া যায়নি।",
            offline: "{{number}} বিল এই কাউন্টারে নেই, আর সার্ভারে যোগাযোগ করা যাচ্ছে না। রসিদ ছাড়া ফেরত নিন।",
            beforeReturns: "এই বিলটি এই কাউন্টারে ফেরত চালুর আগের। রসিদ ছাড়া ফেরত নিন।",
            billTitle: "বিল {{number}}",
            fromHere: "{{time}} · এই কাউন্টার",
            fromServer: "{{time}} · অন্য কাউন্টার",
            receiptlessTitle: "রসিদ ছাড়া ফেরত",
            receiptlessHelp: "ফেরত আসা প্রতিটি পণ্য স্ক্যান বা খুঁজে নিন। আজকের দামে ফেরত হবে।",
            sold: "বিক্রি",
            left: "বাকি",
            back: "ফেরত",
            all: "সব",
            condition: { sellable: "বিক্রিযোগ্য", damaged: "ক্ষতিগ্রস্ত" },
            reason: "কারণ",
            reasons: {
                defective: "ত্রুটিপূর্ণ",
                wrong_item: "ভুল পণ্য",
                changed_mind: "মত বদল",
                expired: "মেয়াদোত্তীর্ণ",
                other: "অন্যান্য",
            },
            note: "নোট (ঐচ্ছিক)",
            value: "ফেরতের মূল্য",
            nothing: "কী ফেরত আসছে বেছে নিন।",
            refund: "টাকা ফেরত",
            exchange: "এক্সচেঞ্জ",
            exceeds: "এই লাইনে আর মাত্র {{left}} ফেরত নেওয়া যাবে।",
            noPermission: "আপনি ফেরত নিতে পারবেন না। ম্যানেজারকে বলুন।",
            changeBill: "অন্য বিল",
        },
        refund: {
            title: "টাকা ফেরত",
            value: "ফেরত পণ্যের মূল্য",
            dues: "কাস্টমারের বাকি থেকে বাদ",
            exchange: "নতুন বিলে জমা",
            owed: "আরও ফেরত দিতে হবে",
            toDues: "কাস্টমারের বাকি",
            reference: "TrxID / স্লিপ নম্বর",
            add: "যোগ করুন",
            complete: "ফেরত সম্পন্ন",
            completeWith: "ফেরত সম্পন্ন · {{amount}} {{method}}",
            remove: "সরান",
            errors: {
                NOTHING_OWED: "আর কিছু ফেরত দেওয়ার নেই।",
                AMOUNT_INVALID: "শূন্যের বেশি পরিমাণ লিখুন।",
                MORE_THAN_OWED: "যা ফেরত দেওয়ার আছে তার চেয়ে বেশি।",
                REFERENCE_REQUIRED: "ফেরতের TrxID বা স্লিপ নম্বর লিখুন।",
                NEEDS_CUSTOMER: "আগে একজন কাস্টমার যুক্ত করুন।",
                TOO_MANY_TENDERS: "অনেক বেশি ফেরতের লাইন।",
                EMPTY: "কিছুই ফেরত আসছে না।",
                NOT_SETTLED: "আগে পুরো টাকা ফেরত দিন।",
                APPROVAL_REQUIRED: "এই ফেরতে ম্যানেজারের অনুমোদন লাগবে।",
                NO_BILL_PREFIX: "এই শাখার বিল প্রিফিক্স নেই। অ্যাডমিনকে সেট করতে বলুন।",
                INVALID: "ফেরতটি সেভ করা যায়নি। পরিমাণগুলো দেখুন।",
            },
        },
        returnDone: {
            title: "ফেরত সম্পন্ন",
            number: "ফেরত {{number}}",
            giveBack: "ফেরত দিন",
            toDues: "বাকি থেকে বাদ",
            exchangeCredit: "নতুন বিলে জমা",
            done: "শেষ",
        },
        exchange: {
            banner: "{{bill}} বিলের এক্সচেঞ্জ · ক্রেডিট {{amount}}",
            bannerNoReceipt: "রসিদ ছাড়া এক্সচেঞ্জ · ক্রেডিট {{amount}}",
            cancel: "এক্সচেঞ্জ বাতিল",
            credit: "এক্সচেঞ্জ ক্রেডিট",
            rest: "বাকি টাকা ফেরত",
        },
        shift: {
            title: "শিফট শুরু করুন",
            description: "প্রথম বিক্রির আগে ড্রয়ারে থাকা নগদ টাকা গুনে লিখুন।",
            float: "ড্রয়ারে নগদ (৳)",
            open: "শিফট শুরু",
            opened: "শিফট শুরু হয়েছে।",
        },
        pay: {
            title: "পেমেন্ট",
            total: "দিতে হবে",
            paid: "পরিশোধ",
            due: "এখনো বাকি",
            change: "ফেরত",
            amount: "পরিমাণ (৳)",
            reference: "TrxID",
            cardReference: "কার্ড স্লিপ / শেষ ৪ অঙ্ক (ঐচ্ছিক)",
            add: "যোগ করুন",
            exact: "ঠিক যত",
            complete: "বিক্রি সম্পন্ন",
            completeWith: "বিক্রি সম্পন্ন · {{amount}} {{method}}",
            completeExact: "বিক্রি সম্পন্ন · {{amount}} {{method}} (ঠিক যত)",
            exactHint: "ঠিক যত: {{amount}}",
            completing: "সংরক্ষণ হচ্ছে…",
            remove: "পেমেন্ট সরান",
            methods: {
                cash: "নগদ",
                card: "কার্ড",
                bkash: "বিকাশ",
                nagad: "নগদ (Nagad)",
                rocket: "রকেট",
                credit: "বাকিতে",
            },
            noAccount: "এই কাউন্টারে কোনো {{method}} অ্যাকাউন্ট নেই।",
            setupAccounts: "নগদের জন্য এই কাউন্টারের ক্যাশ ড্রয়ার লাগবে; অন্য পদ্ধতির জন্য তাদের অ্যাকাউন্ট। Admin → পেমেন্ট → অ্যাকাউন্টে যোগ করে সিঙ্ক করুন।",
            creditLimit: "সীমা {{limit}} · এখন বাকি {{balance}}",
            pendingVerification: "পরে {{method}} স্টেটমেন্টের সাথে মিলিয়ে দেখা হবে।",
            errors: {
                NOTHING_DUE: "আর কিছু বাকি নেই।",
                AMOUNT_INVALID: "পরিমাণ লিখুন।",
                MORE_THAN_DUE: "বাকির চেয়ে বেশি।",
                REFERENCE_REQUIRED: "TrxID দিন (৮–২০টি অক্ষর ও সংখ্যা)।",
                TOO_MANY_TENDERS: "একটি বিলে সর্বোচ্চ ১০টি পেমেন্ট।",
                NEEDS_CUSTOMER: "আগে কাস্টমার যোগ করুন (F7)।",
                OVER_CREDIT_LIMIT: "এতে কাস্টমারের বাকির সীমা ছাড়িয়ে যাবে।",
                NOT_PAID: "বিল পুরো পরিশোধ হয়নি।",
                NO_BILL_PREFIX: "এই শাখার এখনো বিল প্রিফিক্স নেই। Admin-এ সেট করুন।",
                INVALID: "বিক্রি সংরক্ষণ করা গেল না। লাইনগুলো দেখে আবার চেষ্টা করুন।",
            },
        },
        done: {
            title: "বিক্রি সম্পন্ন",
            change: "ফেরত দিন",
            noChange: "ফেরত নেই",
            bill: "বিল {{number}}",
            printing: "প্রিন্ট হচ্ছে…",
            printed: "রসিদ প্রিন্ট হয়েছে।",
            noPrinter: "কোনো প্রিন্টার সেট করা নেই। প্রিন্টার সেটিংসে যোগ করুন।",
            printFailed: "রসিদ প্রিন্ট হয়নি: {{message}}",
            retry: "আবার প্রিন্ট",
            next: "পরের ক্রেতা",
        },
        bills: {
            title: "সাম্প্রতিক বিল",
            empty: "এই কাউন্টারে এখনো কোনো বিল নেই।",
            reprint: "আবার প্রিন্ট",
            a4: "A4 ইনভয়েস",
            reprinted: "রসিদ আবার প্রিন্ট হয়েছে।",
        },
        printers: {
            title: "প্রিন্টার",
            empty: "এখনো কোনো প্রিন্টার নেই।",
            add: "প্রিন্টার যোগ করুন",
            name: "নাম",
            kind: "সংযোগ",
            network: "নেটওয়ার্ক (IP)",
            system: "এই কম্পিউটারে ইনস্টল করা (USB)",
            address: "IP ঠিকানা",
            queue: "প্রিন্টার",
            paper: "কাগজ",
            paperSize: "{{size}} মিমি",
            drawer: "নগদ বিক্রিতে ক্যাশ ড্রয়ার খুলুন",
            makeDefault: "রসিদের জন্য ব্যবহার করুন",
            isDefault: "ডিফল্ট",
            test: "টেস্ট প্রিন্ট",
            openDrawer: "ড্রয়ার খুলুন",
            remove: "সরান",
            testOk: "টেস্ট পেজ পাঠানো হয়েছে।",
            approve: "প্রিন্টার বদলাতে ম্যানেজারের পিন লাগবে।",
        },
        sale: {
            scanPlaceholder: "বারকোড স্ক্যান করুন, অথবা খুঁজতে লিখুন (F2)",
            scanLabel: "স্ক্যান বা খোঁজ",
            cart: "কার্ট {{n}}",
            newCart: "নতুন কার্ট",
            emptyTitle: "শুরু করতে স্ক্যান করুন বা খুঁজুন",
            emptyHelp: "বারকোড স্ক্যানার যেকোনো সময় কাজ করে। তিনটি যোগ করতে স্ক্যানের আগে 3* লিখুন।",
            notFound: "{{code}} কোডের কোনো পণ্য নেই।",
            archived: "{{name}} বিক্রির জন্য নয়।",
            tooManyLines: "একটি বিলে সর্বোচ্চ ৫০০ লাইন থাকতে পারে।",
            qtyOutOfRange: "এই পরিমাণ সম্ভব নয়।",
            tabsFull: "নয়টি কার্ট খোলা। আগে একটি হোল্ড বা শেষ করুন।",
            nothingToHold: "কার্ট খালি।",
            held: "বিল হোল্ড করা হয়েছে।",
            notAllowed: "এই কাউন্টারে বিক্রির অনুমতি আপনার নেই।",
            noLongerInCatalog: "আর ক্যাটালগে নেই",
            columns: { item: "পণ্য", qty: "পরিমাণ", price: "দাম", discount: "ছাড়", total: "মোট" },
            stock: "স্টক {{qty}}",
            mrp: "MRP {{amount}}",
            searchEmpty: "“{{query}}”-এর সাথে মেলে এমন কোনো পণ্য নেই।",
            searchHint: "অন্তত ২টি অক্ষর লিখুন।",
            quickKeys: "দ্রুত বোতাম",
            quickKeysEmpty: "এখনো পণ্যসহ কোনো ক্যাটাগরি নেই।",
            backToCategories: "সব ক্যাটাগরি",
            totals: {
                subtotal: "সাবটোটাল",
                lineDiscounts: "পণ্যের ছাড়",
                billDiscount: "বিলের ছাড়",
                vat: "ভ্যাট",
                total: "মোট",
                items_one: "{{formatted}}টি পণ্য",
                items_other: "{{formatted}}টি পণ্য",
            },
            customer: {
                title: "কাস্টমার",
                none: "সাধারণ ক্রেতা",
                attach: "কাস্টমার যোগ করুন",
                change: "বদলান",
                remove: "সরান",
                phone: "মোবাইল নম্বর",
                name: "নাম",
                find: "খুঁজুন",
                create: "যোগ করে যুক্ত করুন",
                invalidPhone: "বাংলাদেশি মোবাইল নম্বর দিন।",
                notFoundNew: "এই নম্বরে এখনো কোনো কাস্টমার নেই। নতুন তৈরি করতে নাম দিন।",
                due: "বাকি {{amount}}",
                created: "কাস্টমার যোগ হয়েছে।",
            },
            note: { title: "নোট", placeholder: "এই বিলের জন্য নোট", add: "নোট যোগ করুন", save: "নোট সংরক্ষণ" },
            discount: {
                line: "পণ্যের ছাড়",
                bill: "বিলের ছাড়",
                amount: "টাকা (৳)",
                percent: "শতাংশ (%)",
                value: "ছাড়",
                apply: "প্রয়োগ করুন",
                remove: "ছাড় সরান",
                overLimit: "এটি অনুমোদিত {{limit}}-এর বেশি। একজন ম্যানেজারকে অনুমোদন দিতে হবে।",
                approved: "{{name}} অনুমোদন দিয়েছেন।",
            },
            qty: { title: "পরিমাণ", label: "পরিমাণ ({{unit}})", apply: "ঠিক করুন" },
            weight: { title: "{{name}} ওজন করুন", label: "ওজন ({{unit}})", add: "যোগ করুন" },
            heldList: {
                title: "হোল্ড করা বিল",
                empty: "কোনো হোল্ড করা বিল নেই।",
                resume: "আবার খুলুন",
                heldAt: "হোল্ড {{time}}",
            },
            actions: {
                quantity: "পরিমাণ",
                increase: "আরও একটি",
                decrease: "একটি কম",
                discount: "ছাড়",
                billDiscount: "বিলের ছাড়",
                customer: "কাস্টমার",
                note: "নোট",
                hold: "হোল্ড",
                heldBills: "হোল্ড করা বিল",
                remove: "লাইন সরান",
                clear: "কার্ট খালি করুন",
                pay: "পেমেন্ট",
                signOut: "সাইন আউট",
                bills: "সাম্প্রতিক বিল",
                printers: "প্রিন্টার",
                shift: "শিফট",
                returns: "ফেরত",
            },
            clearConfirm: "এই কার্টের সব লাইন সরাবেন?",
            closeCart: "{{name}} বন্ধ করুন",
            closeTitle: "{{name}} বন্ধ করবেন?",
            closeBody: "এতে {{lines}}টি পণ্য আছে। পরে শেষ করতে হোল্ড করুন, অথবা খালি করুন — খালি করতে ম্যানেজারের অনুমতি লাগবে।",
            closeHold: "পরের জন্য হোল্ড",
            closeClear: "খালি করে বন্ধ",
        },
        sync: {
            suspended: "সাবস্ক্রিপশন স্থগিত — বিক্রি চলবে। মালিককে Sobthik প্ল্যানের পেমেন্ট করতে বলুন।",
            downloading: "দোকানের ডেটা নামানো হচ্ছে…",
            downloadingHelp: "এই কম্পিউটারে একবারই লাগে। শেষ হলে বিক্রি শুরু করা যাবে।",
            datasets: {
                settings: "সেটিংস",
                staff: "কর্মী",
                payment_accounts: "পেমেন্ট অ্যাকাউন্ট",
                categories: "ক্যাটাগরি",
                items: "পণ্য",
                stock: "স্টক",
                customers: "কাস্টমার",
            },
            rows: "{{total}}-এর মধ্যে {{done}}",
            waiting: "চালিয়ে যেতে ইন্টারনেটের অপেক্ষা…",
            online: "অনলাইন",
            offline: "অফলাইন",
            lastSync: "সিঙ্ক হয়েছে {{time}}",
            never: "এখনো সিঙ্ক হয়নি",
            pending_one: "{{formatted}}টি পাঠানো বাকি",
            pending_other: "{{formatted}}টি পাঠানো বাকি",
            allSent: "সব পাঠানো হয়েছে",
            sending: "পাঠানো হচ্ছে…",
            blocked: "সিঙ্ক আটকে আছে",
            upgrade: "আপডেট দরকার",
            stalled: "১৫+ মিনিট পাঠানো যায়নি",
            details: "সিঙ্কের বিবরণ",
            status: "সংযোগ",
            toSend: "পাঠানো বাকি",
            oldest: "সবচেয়ে পুরোনোটি যখন থেকে",
            review: "অ্যাডমিনে যাচাই দরকার",
            lastPush: "শেষ পাঠানো",
            none: "—",
            syncNow: "এখনই সিঙ্ক করুন",
            blockedHelp: "সার্ভার এই কম্পিউটার থেকে {{seq}} নম্বর কমান্ডের অপেক্ষায় আছে, যা এখানে নেই। বিক্রি চলবে; অ্যাডমিন → POS ডিভাইস থেকে ম্যানেজারকে সমাধান করতে বলুন।",
            upgradeHelp: "আরও বিল নেওয়ার আগে সার্ভার এই অ্যাপের নতুন ভার্সন চায়। বিক্রি চলবে, বিলগুলো এখানে নিরাপদে অপেক্ষা করবে।",
            stalledHelp: "ইন্টারনেট থাকা সত্ত্বেও বিলগুলো ১৫ মিনিটের বেশি অপেক্ষা করছে। বিক্রি চালিয়ে যান; এমনই থাকলে ম্যানেজারকে জানান।",
            offlineHelp: "বিলগুলো এই কম্পিউটারে সংরক্ষিত থাকে, ইন্টারনেট ফিরলে পাঠানো হয়।",
            redownload: "ডেটা আবার নামান",
            redownloadHelp: "পণ্য, দাম, স্টক ও কর্মীদের তালিকা আবার নামানো হবে। এই কম্পিউটারের বিলগুলো থাকবে।",
            redownloadStarted: "ডেটা আবার নামানো হচ্ছে…",
        },
        pairing: {
            title: "এই কম্পিউটার পেয়ার করুন",
            description: "Admin-এ POS ডিভাইস খুলে এই ক্যাশ কাউন্টারের জন্য একটি পেয়ারিং কোড তৈরি করুন এবং এখানে লিখুন।",
            code: "পেয়ারিং কোড",
            submit: "পেয়ার করুন",
            syncing: "পেয়ার হচ্ছে…",
            notFound: "কোডটি ভুল, ব্যবহৃত বা মেয়াদোত্তীর্ণ। Admin-এ নতুন কোড তৈরি করুন।",
            offline: "পেয়ার করতে ইন্টারনেট লাগে। সংযোগ দেখে আবার চেষ্টা করুন।",
            failed: "পেয়ার শেষ হয়নি। আবার চেষ্টা করুন।",
            stepsTitle: "কীভাবে পেয়ার করবেন",
            step1: "Admin-এ POS ডিভাইস খুলুন।",
            step2: "ক্যাশ কাউন্টার পেয়ার করুন বেছে এই কাউন্টারটি দিন এবং কোড তৈরি করুন।",
            step3: "৮ অক্ষরের কোডটি এখানে লিখুন। এটি একবার, ১০ মিনিটের জন্য কাজ করে।",
            codeHint: "অক্ষর ও সংখ্যা; ড্যাশ না দিলেও চলে।",
            codePlaceholder: "XXXX-XXXX",
        },
        login: {
            title: "কে বিক্রি করছেন?",
            noStaff: "এখনো কোনো কর্মী সিঙ্ক হয়নি। কর্মীরা সাইন ইন করতে একবার ইন্টারনেটে যুক্ত হন।",
            pin: "{{name}}-এর পিন",
            submit: "সাইন ইন",
            back: "ফিরে যান",
            wrongPin_one: "ভুল পিন। লক হওয়ার আগে আর {{count}} বার চেষ্টা করা যাবে।",
            wrongPin_other: "ভুল পিন। লক হওয়ার আগে আর {{count}} বার চেষ্টা করা যাবে।",
            locked: "৫ বার ভুল পিনের কারণে {{time}} পর্যন্ত লক।",
            noPin: "{{name}}-এর এখনো POS পিন নেই। Admin → নিরাপত্তা-তে সেট করে সিঙ্ক করুন।",
            managerUnlock: "ম্যানেজার দিয়ে খুলুন",
            manager: "ম্যানেজার",
            managerPin: "ম্যানেজারের পিন",
            unlock: "খুলুন",
            unlocked: "খোলা হয়েছে। আবার পিন দিন।",
            denied: "এই ম্যানেজার খুলতে পারেন না, অথবা পিন ভুল।",
            chooseManager: "ম্যানেজার বাছুন",
            subtitle: "আপনার নামে চাপুন, তারপর পিন দিন।",
            changePerson: "আপনি নন?",
            noPinBadge: "পিন নেই",
            keypadClear: "মুছুন",
            keypadDelete: "শেষ অঙ্ক মুছুন",
            lockedTitle: "আপাতত লক",
        },
        updates: {
            ready: "ভার্সন {{version}} প্রস্তুত",
            readyHelp: "ইনস্টল হতে প্রায় এক মিনিট লাগে; POS আবার চালু হবে, কর্মীরা আবার সাইন ইন করবেন।",
            downloading: "ভার্সন {{version}} নামানো হচ্ছে…",
            install: "ইনস্টল করে আবার চালু করুন",
            shiftOpen: "আগে শিফট বন্ধ করুন: শিফট চলাকালে আপডেট ইনস্টল হয় না।",
            required: "POS-এর এই ভার্সন আর চলবে না",
            requiredHelp: "বিক্রি চালিয়ে যেতে আপডেট করুন। এই কম্পিউটারের বিলগুলো থাকবে।",
            requiredShift: "শিফট শেষ করে বন্ধ করুন, তারপর আপডেট করুন। শিফট বন্ধ হলে নতুন সাইন ইন হবে না।",
            requiredWaiting: "আপডেট এখনো নামানো হয়নি। ইন্টারনেট সংযোগ দেখুন।",
            installFailed: "আপডেট ইনস্টল করা যায়নি। আবার চেষ্টা করুন।",
            betaJoin: "বেটা আপডেট নিন",
            betaLeave: "বেটা আপডেট বন্ধ করুন",
            betaHelp: "বেটা ভার্সন আগে কয়েকটি কাউন্টারে আসে। শুধু সেই কাউন্টারে নিন যেটি ম্যানেজার কাছ থেকে দেখেন।",
            betaOn: "এই কাউন্টার এখন বেটা আপডেট পাবে।",
            betaOff: "এই কাউন্টার এখন স্থিতিশীল আপডেট পাবে।",
        },
        protection: {
            unpair: "এই কম্পিউটার আনপেয়ার করুন",
            unpairHelp: "এই কম্পিউটার আর ক্যাশ কাউন্টার থাকবে না। এর ডেটা এখানেই আর্কাইভে থাকবে; আবার পেয়ার করুন বা অন্য কাউন্টার পেয়ার করে চালিয়ে যান।",
            unpairConfirm: "আনপেয়ার করুন",
            unpairPending_one: "{{formatted}}টি রেকর্ড এখনো সার্ভারে পৌঁছায়নি। এটি আর্কাইভে থাকবে, আবার পেয়ার করার পর উদ্ধার করা যাবে — ইন্টারনেট থাকলে আগে সিঙ্ক করুন।",
            unpairPending_other: "{{formatted}}টি রেকর্ড এখনো সার্ভারে পৌঁছায়নি। এগুলো আর্কাইভে থাকবে, আবার পেয়ার করার পর উদ্ধার করা যাবে — ইন্টারনেট থাকলে আগে সিঙ্ক করুন।",
            recoverTitle: "আগের পেয়ারিংয়ের না-পাঠানো রেকর্ড",
            recoverBody_one: "কাউন্টার {{code}}-এর {{formatted}}টি রেকর্ড সার্ভারে পৌঁছায়নি (আর্কাইভ {{time}})।",
            recoverBody_other: "কাউন্টার {{code}}-এর {{formatted}}টি রেকর্ড সার্ভারে পৌঁছায়নি (আর্কাইভ {{time}})।",
            recover: "এখনই উদ্ধার করুন",
            recoverHelp: "এগুলো পুরোনো কাউন্টার হিসেবে পাঠানো হবে, আর অ্যাডমিন → POS যাচাইয়ে প্রতিটি ম্যানেজারের দেখার জন্য চিহ্নিত থাকবে।",
            recoverOffline: "উদ্ধার করতে ইন্টারনেটে যুক্ত হন।",
            recovered: "উদ্ধার হয়েছে: {{processed}}টি পাঠানো হলো, {{replayed}}টি আগেই সার্ভারে ছিল।",
            recoverBlocked: "সার্ভারে ওই কাউন্টারের {{seq}} নম্বর রেকর্ড নেই, এই আর্কাইভেও নেই। মালিককে অ্যাডমিন → POS ডিভাইস দেখতে বলুন।",
            recoverFailed: "উদ্ধার থেমে গেছে। ইন্টারনেট দেখে আবার চেষ্টা করুন।",
            restoreTitle: "ব্যাকআপ থেকে ফিরিয়ে আনুন",
            restoreHelp: "এই কম্পিউটারের কাউন্টারের ডেটা খোলা যায়নি। একই কাউন্টার হিসেবে চালাতে সবচেয়ে নতুন ঘণ্টাভিত্তিক ব্যাকআপ ফিরিয়ে আনুন।",
            restoreFrom: "{{time}}-এর ব্যাকআপ",
            restore: "ফিরিয়ে আনুন",
            restoreFailed: "ব্যাকআপ ফিরিয়ে আনা যায়নি।",
            signOutTitle: "রেকর্ড এখনো পাঠানো হয়নি",
            signOut_one: "{{formatted}}টি রেকর্ড এখনো সার্ভারে পৌঁছায়নি। এটি এই কম্পিউটারে নিরাপদ, অনলাইন হলে পাঠানো হবে।",
            signOut_other: "{{formatted}}টি রেকর্ড এখনো সার্ভারে পৌঁছায়নি। এগুলো এই কম্পিউটারে নিরাপদ, অনলাইন হলে পাঠানো হবে।",
            signOutAnyway: "সাইন আউট",
        },
        revoked: {
            title: "এই POS বাতিল করা হয়েছে",
            body: "একজন ম্যানেজার এই কম্পিউটারটি সরিয়ে দিয়েছেন। যে বিল পাঠানো হয়নি সেগুলো এতে নিরাপদে আছে; উদ্ধার করতে ম্যানেজারকে বলুন।",
        },
    },
    /** SB-04: "নিজে চালিয়ে দেখুন" ডেমোর ব্রাউজার POS (ডেস্কটপ অ্যাপে কখনো নয়)। */
    demo: {
        badge: "ডেমো POS",
        internet: "ইন্টারনেট",
        on: "চালু",
        off: "বন্ধ",
        offlineHint: "বিল এই কম্পিউটারেই থাকে, নেট ফিরলে নিজেই সিঙ্ক হয়।",
        pin: "সব ক্যাশিয়ারের PIN: {{pin}}",
        receiptTitle: "রিসিট",
        receiptNote: "আসল কাউন্টারে এটা থার্মাল প্রিন্টারে প্রিন্ট হয়।",
        close: "বন্ধ করুন",
        pairingFailed: "এই ডেমো লিংকের মেয়াদ শেষ। ডেমো দোকানের Admin থেকে আবার POS খুলুন।",
    },
    devices: {
        title: "POS ডিভাইস",
        description: "যেসব কম্পিউটারে POS অ্যাপ চলে, প্রতি ক্যাশ কাউন্টারে একটি। বাতিল করলে পরের সংযোগে ডিভাইসটি লক হয়ে যায়।",
        empty: "এখনো কোনো POS ডিভাইস নেই। বিক্রি শুরু করতে একটি ক্যাশ কাউন্টার পেয়ার করুন।",
        pair: "ক্যাশ কাউন্টার পেয়ার করুন",
        filters: { status: "অবস্থা", all: "সব", active: "চালু", revoked: "বাতিল" },
        columns: {
            name: "ডিভাইস",
            code: "কোড",
            location: "শাখা",
            platform: "সিস্টেম",
            pairedAt: "পেয়ার হয়েছে",
            status: "অবস্থা",
            sync: "সিঙ্ক",
            lastSeen: "শেষ দেখা",
            version: "ভার্সন",
            pending: "পাঠানো বাকি",
        },
        health: {
            online: "অনলাইন",
            offline: "অফলাইন",
            stalled: "পাঠাচ্ছে না",
            never: "কখনো সংযুক্ত হয়নি",
            gap: "{{seq}} নম্বর কমান্ডের অপেক্ষায়",
            oldest: "সবচেয়ে পুরোনো {{time}}",
        },
        stats: {
            online: "এখন অনলাইন",
            onlineHint: "{{total}}টি চালু ডিভাইসের মধ্যে",
            stalled: "পাঠাচ্ছে না",
            stalledHint: "অনলাইন, বিল ১৫+ মিনিট অপেক্ষায়",
            pending: "পাঠানো বাকি বিল",
            pendingHint: "এখনো কাউন্টারে আছে",
        },
        revokePending_one: "এই ডিভাইসে এখনো {{formatted}}টি কমান্ড পাঠানো বাকি। কম্পিউটার হারালে বা বদলালে তবেই বাতিল করুন, তারপর বিলগুলো উদ্ধার করুন।",
        revokePending_other: "এই ডিভাইসে এখনো {{formatted}}টি কমান্ড পাঠানো বাকি। কম্পিউটার হারালে বা বদলালে তবেই বাতিল করুন, তারপর বিলগুলো উদ্ধার করুন।",
        platforms: { windows: "Windows", macos: "macOS", linux: "Linux" },
        active: "চালু",
        revoked: "বাতিল",
        revoke: "বাতিল করুন",
        revokeTitle: "এই ডিভাইসটি বাতিল করবেন?",
        revokeBody: "এটি আর সিঙ্ক করবে না এবং পরের সংযোগে লক হয়ে যাবে। যে বিল এখনো পাঠানো হয়নি সেগুলো ডিভাইসেই থাকবে এবং উদ্ধার করা যাবে।",
        revokedToast: "ডিভাইস বাতিল হয়েছে।",
        pairing: {
            title: "ক্যাশ কাউন্টার পেয়ার করুন",
            description: "একটি এককালীন কোড তৈরি করুন, তারপর সেই কম্পিউটারের POS অ্যাপে কোডটি লিখুন।",
            location: "শাখা",
            register: "ক্যাশ কাউন্টার",
            name: "ডিভাইসের নাম",
            namePlaceholder: "সামনের কাউন্টারের পিসি",
            chooseLocation: "শাখা বাছুন",
            chooseRegister: "ক্যাশ কাউন্টার বাছুন",
            noRegisters: "এই শাখায় খালি কোনো চালু ক্যাশ কাউন্টার নেই।",
            create: "কোড তৈরি করুন",
            codeLabel: "পেয়ারিং কোড",
            codeHelp: "POS অ্যাপে এই কোডটি লিখুন। এটি একবারই কাজ করে।",
            expires: "{{time}} পর্যন্ত বৈধ",
            expired: "কোডের মেয়াদ শেষ। নতুন একটি তৈরি করুন।",
            another: "আরেকটি কোড তৈরি করুন",
        },
    },
    pin: {
        title: "POS পিন",
        description: "POS-এ সাইন ইন করার ৪–৬ অঙ্কের পিন, অফলাইনেও কাজ করে।",
        isSet: "আপনার POS পিন সেট করা আছে।",
        notSet: "আপনার এখনো কোনো POS পিন নেই।",
        set: "পিন সেট করুন",
        change: "পিন বদলান",
        pin: "নতুন পিন",
        confirm: "পিন আবার লিখুন",
        mismatch: "দুটি পিন মেলেনি।",
        saved: "POS পিন সংরক্ষিত হয়েছে। পরের সিঙ্কে ডিভাইসগুলো এটি পাবে।",
    },
    reviews: {
        title: "POS রিভিউ",
        description: "POS ডিভাইস থেকে আসা যেসব বিল ও এন্ট্রি একবার দেখা দরকার। আটকে থাকা এন্ট্রি এখনো কিছু বদলায়নি: আবার চালান বা বাতিল করুন।",
        empty: "রিভিউ করার কিছু নেই।",
        filters: { status: "অবস্থা", all: "সব" },
        columns: {
            type: "কী",
            reasons: "কারণ",
            reference: "রেফারেন্স",
            state: "ফল",
            occurredAt: "কখন (ডিভাইস)",
            status: "অবস্থা",
        },
        applied: "রেকর্ড হয়েছে",
        held: "আটকে আছে",
        statuses: {
            open: "খোলা",
            acknowledged: "দেখা হয়েছে",
            reprocessed: "আবার চালানো হয়েছে",
            voided: "বাতিল",
        },
        types: {
            SaleCompleted: "বিক্রি",
            ReturnCompleted: "ফেরত",
            ShiftOpened: "শিফট শুরু",
            ShiftClosed: "শিফট শেষ",
            CashMovementRecorded: "ক্যাশ জমা / উত্তোলন",
            CustomerCreated: "নতুন গ্রাহক",
            PosActivityRecorded: "কার্যকলাপ",
            unknown: "অজানা এন্ট্রি",
        },
        reasons: {
            STAFF_INACTIVE: "কর্মী নিষ্ক্রিয় করা হয়েছিল",
            STAFF_NOT_PERMITTED: "এখানে কর্মীর অনুমতি নেই",
            APPROVAL_INVALID: "ম্যানেজারের অনুমোদন নেই বা বৈধ নয়",
            RETURN_EXCEEDS_SOLD: "বিক্রির চেয়ে বেশি ফেরত",
            TOTALS_MISMATCH: "ডিভাইসের হিসাব সার্ভারের সাথে মেলেনি",
            PAYMENT_MISMATCH: "পেমেন্ট বিলের সাথে মেলেনি",
            CREDIT_LIMIT_EXCEEDED: "গ্রাহক বাকির সীমা ছাড়িয়েছেন",
            SHIFT_NOT_OPEN: "শিফট খোলা ছিল না",
            SHIFT_OVERLAP: "রেজিস্টারে আরেকটি শিফট খোলা ছিল",
            SHIFT_TOTALS_MISMATCH: "প্রত্যাশিত ক্যাশ সার্ভারের হিসাবের সাথে মেলেনি",
            DUPLICATE_NUMBER: "বিল নম্বর আগেই ব্যবহৃত (নতুন নম্বর দেওয়া হয়েছে)",
            SEQ_REUSED: "ডিভাইস পুরোনো ক্রম নম্বর পাঠিয়েছে",
            ORIGINAL_NOT_FOUND: "মূল বিল এখনো সার্ভারে আসেনি",
            RECEIPTLESS_RETURN: "রসিদ ছাড়া ফেরত",
            UNKNOWN_REFERENCE: "অজানা পণ্য, অ্যাকাউন্ট বা গ্রাহক",
            DUPLICATE_ENTITY_ID: "আইডি আরেকটি এন্ট্রিতে ব্যবহৃত",
            INVALID_COMMAND: "এন্ট্রি পড়া যায়নি",
            SCHEMA_VERSION_UNSUPPORTED: "এই POS অ্যাপ সংস্করণ সমর্থিত নয়",
            PROCESSING_FAILED: "সার্ভার প্রক্রিয়া করতে পারেনি",
            RECOVERED: "পুরোনো POS ডেটাবেস থেকে উদ্ধার করা",
        },
        detail: {
            title: "রিভিউ",
            device: "ডিভাইসের ক্রম",
            reference: "রেফারেন্স",
            payload: "যেভাবে পাঠানো হয়েছে",
            note: "নোট",
            notePlaceholder: "কেন (বাতিল করতে লাগবে)",
            resolvedBy: "নিষ্পত্তি",
        },
        actions: {
            acknowledge: "দেখেছি",
            reprocess: "আবার চালান",
            void: "বাতিল",
        },
        resolved: "রিভিউ নিষ্পত্তি হয়েছে।",
    },
};
//# sourceMappingURL=pos.js.map